import { ScanResultsAvailability } from "hooks/useScanResultsAvailability";

export type DatasetSource = "scanResults" | "folder";

interface SourceOption {
  id: DatasetSource;
  title: string;
  description: string;
}

export const SOURCE_OPTIONS: SourceOption[] = [
  {
    id: "scanResults",
    title: "Import from Scan Result",
    description:
      "Browse wafer scan results from DataServer and pick the ones to import.",
  },
  {
    id: "folder",
    title: "Select folder",
    description:
      "Enter the path of a folder that already holds your prepared data.",
  },
];

/** Why scan results cannot be picked yet, or empty when they can. */
export const getScanResultsDisabledReason = (
  availability: ScanResultsAvailability | null,
): string => {
  if (!availability) return "Checking DataServer availability...";
  if (availability.available) return "";
  if (!availability.enabled)
    return "Not available yet - DataServer is not enabled for this deployment.";
  if (!availability.configured)
    return "Not available yet - DataServer is not configured for this deployment.";
  return "Not available right now - DataServer could not be reached.";
};
